import { format as formatDate, formatISO } from 'date-fns';
import type { DateInput, TimeFormat } from '../types';
import { getLocale } from './common';

export const getTimeLabel = (localeCode: string, inputDate: DateInput, format?: TimeFormat) => {
  const locale = getLocale(localeCode);
  const date = new Date(inputDate);

  switch (format) {
    case 'date':
      return formatDate(date, 'PPPP', { locale });
    case 'time':
      return formatDate(date, 'p', { locale });
    default:
      return formatDate(date, 'PPPPp', { locale });
  }
};

/**
 * @return An ISO 8601 formatted string representing the date passed in. Suitable to use for the `datetime` attribute of the `<time>` element.
 */
export const getDateTime = (inputDate: DateInput) => {
  const date = new Date(inputDate);

  return formatISO(date);
};
